<template>
  <SenhaForm v-model="senha" @on-submit="submit" @on-voltar="goBack" @on-recuperar-senha="onRecuperarSenha"
    :check-termos.sync="termos" :senha-confirmacao.sync="senhaConfirmacao" :novo-acesso="novoAcesso" ref="form" />
</template>

<script>
import authenticationService from '@/services/authentication'
import { mapActions } from 'vuex'

const SenhaForm = () => import('@/modules/Login/SenhaForm')

export default {
  components: {
    SenhaForm
  },
  data: () => ({
    senhaConfirmacao: ''
  }),
  computed: {
    novoAcesso() {
      return !!this.$route.query.novoAcesso
    },
    senha: {
      get() {
        return this.$store.state.authentication.senha
      },
      set(value) {
        this.$store.commit('authentication/SET_SENHA', value)
      }
    },
    termos: {
      get() {
        return this.$store.state.authentication.termos
      },
      set(value) {
        this.$store.commit('authentication/SET_TERMOS', value)
      }
    }
  },
  methods: {
    ...mapActions('authentication', ['login']),
    ...mapActions('user', ['authenticateUser']),
    ...mapActions('avaliacaoPsicossocial', ['setMapeamentoPsicossocial']),

    getRotaDestino(query) {
      if (query.redirect === 'assinatura') {
        return { name: 'assinatura', query }
      }

      if (query.token || query.encryptedIdMapeamento) {
        return { path: '/avaliacao-psicossocial', query }
      }

      if (query.redirect) {
        return { path: query.redirect }
      }

      return { name: 'dashboard' }
    },

    async handleLogin() {
      this.$showLoading()
      try {
        const data = await this.login(this.senha)
        authenticationService.setToken(data.token)
        data.user.agendamentoExpress = data.agendamentoExpress

        const mapeamentoPsicossocial = {
          token: this.$route.query.token,
          encryptedIdMapeamento: this.$route.query.encryptedIdMapeamento,
          encryptedIdsEmpresas: this.$route.query.encryptedIdsEmpresas
        }

        this.authenticateUser(data.user)
        this.setMapeamentoPsicossocial(mapeamentoPsicossocial)
        this.$setDatadogUser(data.user.id, data.user.nome, data.user.email)

        const rota = this.getRotaDestino(this.$route.query)
        this.$router.push(rota)
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) return

      if (this.novoAcesso) this.$router.push({ name: 'Completar Cadastro', query: this.$route.query })
      else this.handleLogin()
    },
    onRecuperarSenha() {
      this.$router.push({ name: 'Recuperar Senha' })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  beforeMount() {
    this.senha = ''
    this.senhaConfirmacao = ''
    this.termos = false
  }
}
</script>
